// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single-page-content-wrapper {
	display: flex;
	flex-direction: column;
	width: 60%;
}

@media (max-width: 768px) {
	.single-page-content-wrapper {
		width: 80%;
	}
}

@media (max-width: 670px) {
	.single-page-content-wrapper {
		width: 90%;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/elements/single-page-item/single-page-item.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,UAAU;AACX;;AAEA;CACC;EACC,UAAU;CACX;AACD;;AAEA;CACC;EACC,UAAU;CACX;AACD","sourcesContent":[".single-page-content-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 60%;\n}\n\n@media (max-width: 768px) {\n\t.single-page-content-wrapper {\n\t\twidth: 80%;\n\t}\n}\n\n@media (max-width: 670px) {\n\t.single-page-content-wrapper {\n\t\twidth: 90%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
